// Updated AuthContext - Consistent token key "apiToken", token in state
import React, { createContext, useContext, useState, useEffect } from "react";
import { API_URL } from "../../confi";
const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  async function login(email, password) {
    try {
      const res = await fetch(`${API_URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      // console.log("API Response:", JSON.stringify(data, null, 2));

      let tokenValue = null;
      if (Array.isArray(data) && data.length > 0) {
        tokenValue = data[0];
      } else if (typeof data === "string") {
        tokenValue = data;
      } else {
        tokenValue = data.token || data.access_token || data.data?.token; // Added support for nested token
      }

      // console.log("Extracted Token:", tokenValue);

      if (res.ok && tokenValue) {
        // Store new token every login - overwrites old one
        localStorage.setItem("apiToken", tokenValue);
        localStorage.setItem("authUser", JSON.stringify({ email }));
        setToken(tokenValue); // Update state with new token
        setCurrentUser({ email });
        // console.log("New token stored and set in context");
        return { success: true, user: { email } };
      } else {
        return { success: false, message: data.message || "Login failed" };
      }
    } catch (error) {
      console.error("Login error:", error);
      return { success: false, message: "Something went wrong" };
    }
  }

  function logout() {
    localStorage.removeItem("apiToken");
    localStorage.removeItem("authUser");
    setToken(null);
    setCurrentUser(null);
    // console.log("Logged out - token cleared");
  }

  useEffect(() => {
    const storedToken = localStorage.getItem("apiToken");
    const user = localStorage.getItem("authUser");
    // console.log("Auth check - stored token:", storedToken ? "Found" : "Not found");

    if (storedToken && user) {
      setToken(storedToken);
      setCurrentUser(JSON.parse(user));
    } else {
      setToken(null);
      setCurrentUser(null);
    }
    setLoading(false);
  }, []);

  const value = {
    currentUser,
    token,
    isAuthenticated: !!token,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}